import { Editor, Transforms } from 'slate';
import { ReactEditor, useReadOnly } from 'slate-react';
import type { PlateElementProps } from 'platejs/react';
import { useEditorRef } from 'platejs/react';
import { Box } from '@mui/material';

import { Blockquote } from 'common/components/Blockquote';
import { asEditor } from 'common/components/ContentEditor/utils/editorHelpers';

export const EditorBlockquote = ({
    element,
    children,
    attributes,
    className,
}: PlateElementProps) => {
    const editor = useEditorRef();
    const readOnly = useReadOnly();

    // Clicking the quote's border/padding (rather than directly on its
    // text) has no text node there for the browser to resolve a caret
    // against, so it can place the cursor in the preceding block instead.
    // If the click landed on the blockquote itself rather than a
    // descendant, explicitly move the selection into the quote.
    const handleMouseDown = (event: React.MouseEvent<HTMLElement>) => {
        if (readOnly || event.target !== event.currentTarget) return;

        event.preventDefault();

        const path = ReactEditor.findPath(
            editor as unknown as ReactEditor,
            element
        );

        Transforms.select(
            asEditor(editor),
            Editor.start(asEditor(editor), path)
        );
        ReactEditor.focus(editor as unknown as ReactEditor);
    };

    return (
        <div className={className} {...attributes}>
            <Box className={className} sx={{ mb: 2 }}>
                <Blockquote
                    onMouseDown={readOnly ? undefined : handleMouseDown}
                >
                    {children}
                </Blockquote>
            </Box>
        </div>
    );
};
